import React from "react"
import { FaLinkedin, FaGithub } from "react-icons/fa"
import { MdEmail } from "react-icons/md"

export default [
  {
    icon: <FaGithub className="github" />,
    title: "github",
  },
  {
    icon: <FaLinkedin className="linkedin" />,
    title: "linkedin",
  },
  {
    icon: <MdEmail className="email" />,
    title: "email",
  },
]
